import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const UNIT_DETAILS_BASE_PATH = `${BASE_PATH_API}/unit/details`;

const actions = {
    /**
     * @summary obtains the filtered list of units with details
     * @returns {Array.<UnitDetailDTO>}
     */
    searchUnits: {
        method: 'POST',
        isArray: true,
        url: `${UNIT_DETAILS_BASE_PATH}/filter`,
        params: {
            '$count': true,
            '$top': '100'
        }
    },
    /**
     * @summary bulk updates the units
     * @returns {Array.<UnitDetailDTO>}
     */
    updateUnits: {
        method: 'PUT',
        url: `${UNIT_DETAILS_BASE_PATH}/bulk`
    }
};

export function UnitDetailsApi() {
    return createActions(actions);
}
